export default ({ request }) => ({
  ecomEvgPurchaseListApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseDetailApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/detail',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseSaveApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/save',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseDelApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseSubmitApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/submit',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseReviewApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/review',
      method: 'POST',
      data,
      timeout: 1000 * 60,
    })
  },
  ecomEvgPurchaseRejectApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/reject',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseDetailOptionsApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/detail/options',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseDetailListApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseDetailAddApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/detail/add',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseDetailUpdateApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/detail/update',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseDetailDelApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/detail/del',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseBatchListApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/batch/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseBatchSelectTotalApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/batch/selectTotal',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchaseBatchSkuListApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/batch/sku/list',
      method: 'POST',
      data,
    })
  },
  ecomEvgPurchasePackingListApi(data = {}) {
    return request({
      url: '/ecom/evg/fty/purchase/packing/list',
      method: 'POST',
      data,
    })
  },
})
